<template>
    <div v-if="isAuthorized">
        <v-main >
            <v-container fluid>
                <v-card id="titlecard" flat>
                    <v-row cols="12" dense>
                        <v-col cols="12">
                            <h2>{{ this.title }}</h2>
                        </v-col>
                    </v-row>
                    <v-row dense cols="12">
                        <v-col cols="2">
                            <v-text-field v-model="search" clearable prepend-icon="mdi-magnify" label="Search through all fields" single-line hide-detail/>
                        </v-col>
                    </v-row>
                </v-card>
                <v-row class="row-default">
                    <v-col cols="12" class="px-2">
                        <v-data-table id="x" 
                            dense 
                            :headers="getUserHeaders()" 
                            :items="users"
                            :items-per-page="15" 
                            :footer-props="{
                                'items-per-page-options': [10, 15, 50, 100, -1]
                            }"
                            item-key="user_code" 
                            :loading="loading"
                            loading-text="Loading data...please wait" 
                            fixed-header 
                            :search="search"
                            :height="wInnerHeight">               
                            <template v-slot:item="user">
                                <tr>
                                    <td class="td_markup">
                                        {{ user.item.gebr_code }}
                                    </td>
                                    <td class="td_markup">
                                        {{ user.item.gebr_naam }}
                                    </td>
                                    <td class="td_markup">
                                        {{ user.item.gebr_actief }}
                                    </td>
                                    <td class="td_markup">
                                        {{ user.item.gebr_used }}
                                    </td>
                                    <td class="td_markup">
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn x-small text icon v-bind="attrs" v-on="on" v-on:click="editUserTasks(user.item)" class="mr-7 mb-2 gridbutton">
                                                    <v-icon>mdi-account-wrench-outline</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Edit user tasks</span>
                                        </v-tooltip> 
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn x-small text icon v-bind="attrs" v-on="on" v-on:click="copyUserTasks(user.item)" class="mr-7 mb-2 gridbutton">
                                                    <v-icon>mdi-account-arrow-right-outline</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Copy user tasks to</span>
                                        </v-tooltip> 
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn x-small text icon v-bind="attrs" v-on="on" v-on:click="editUser(user.item)" class="mr-7 mb-2 gridbutton">
                                                    <v-icon>mdi-account-edit-outline</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Edit user</span>
                                        </v-tooltip> 
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
            </v-container>
        </v-main>
        <updUserTaak ref="updUserTaak" @updateData="updateData"/>
        <cpyUserTaak ref="cpyUserTaak" @updateData="updateData"/>
        <updUserInfo ref="updUserInfo" @updateData="updateData"/>
        <div>
            <navBar :title="'Ares - Users'" :home="true" type="gebr"/>
        </div>
    </div>
</template>

<script>
    import mxauthorization from '@/mixins/authorization';

    import navBar from '@/components/ui/navbars/navbar.vue';
    import updUserTaak from '@/views/syst/gebr/authorization/updUserTaak.vue';
    import cpyUserTaak from '@/views/syst/gebr/authorization/cpyUserTaak.vue';
    import updUserInfo from '@/views/syst/gebr/authorization/updUser.vue';
    

    export default {
        components: {
            navBar,
            updUserTaak,
            cpyUserTaak,
            updUserInfo,
        },    
        mixins: [mxauthorization],
        data() {
            return {
                title: 'User Maintenance',
                isAuthorized: false,
                showUsers: false,
                search: '',
                users: [],
                loading: false,
                wInnerHeight: window.innerHeight - 290, // deduct estimated height for toolbar, searchfield and headers
            }
        },    
        created() { // set up event bus listener here on created event or get data
            window.addEventListener("resize", this.resizeEventHandler);
        },
        destroyed() {
            window.removeEventListener("resize", this.resizeEventHandler);
        },
        mounted() {
            this.getAuthorization("menu-users-authorizations", "isAuthorized");
        },
        watch:{
            isAuthorized(value) { 
                if (value) {
                    // Only get data if the user is authorized
                    this.getUsers();
                }           
            },
        }, 
        methods: {     
            updateData() {
                this.getUsers();
            },
            resizeEventHandler() {
                this.wInnerHeight = window.innerHeight - 290; // deduct estimated height for toolbar, searchfield and headers
            },
            getUsers() {
                this.loading = true;
                this.$axios.post("ares/json/ares/syst/authorization/getUser.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getUser"
                    },
                    getUser: {
                    }
                }).then(res => {
                    if (res.data.header.result == "error") {
                        console.log(res.data.error);
                    } else {
                        this.users = res.data.getUser;
                    }
                    this.loading = false;
                })
            },             
            getUserHeaders() {
                return [
                    { text: "User code", value: "gebr_code", sortable: true, width: '20%' },
                    { text: "User_name", value: "gebr_naam", sortable: true, width: '50%' },
                    { text: "User_actief", value: "gebr_actief", sortable: false, width: '10%' },
                    { text: "# assigned tasks", value: "gebr_tasks", sortable: false, width: '10%' },
                    { text: "Actions", value: "", sortable: false, width: '20%' },
                ];
            },
            editUserTasks(user) {
                this.$refs.updUserTaak.openSelect(user);
            },
            editUser(user) {
                this.$refs.updUserInfo.openSelect(user);
            },
            copyUserTasks(user) {
                this.$refs.cpyUserTaak.openSelect(user);
            },
        }
    }
</script>

<style scoped> 
    .row-pointer {
        cursor: pointer;
    }

    .row-default {
        cursor: default;
    }

    .booking-color {
        color: blue;
    }
    .no-booking-color {
        color: black;
    }    
    .subtitle-weight{
        font-weight: 400;
    }
    .td_markup {
        vertical-align: top;
        border-top: 5px solid transparent !important;
        font-size: 12px !important;
        /* trick to add padding to a TD element (which is not possible with CSS normally) */
    }
    .td_markup_inner {
        vertical-align: top;
        /* border-top: 5px solid transparent; */
        border-top: 0px solid transparent !important;
        font-size: 12px !important;
        /* trick to add padding to a TD element (which is not possible with CSS normally) */
    }
    .td-code{
        width: 7.5em;
    }
    .td-name{
        width: 8em;
    }    
    .td-amount{
        width: 5em;
        text-align: end !important;
    }    
    .td-markup-xs {
        padding-top: 1px;
        padding-bottom: 2px;
        vertical-align: top;        
    }
    .border-xs{
        border-bottom: 1px solid lightgrey;
    }
</style>